export default __webpack_public_path__ + "static/media/KCD.b38a506e.jpg";